import { render, staticRenderFns } from "./PbButton.vue?vue&type=template&id=6bd3c688&"
import script from "./PbButton.vue?vue&type=script&lang=js&"
export * from "./PbButton.vue?vue&type=script&lang=js&"
import style0 from "./PbButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports